export interface I18nLanguage {
    param: string;
    title: string;
    item: string;
}

export enum Locales {
  en = 'en',
  nl = 'nl',
}